import { BenefitResource, benefitResource } from '@witkac/kartamiejska-resources';
import { SessionStorage } from '@witkac/kartamiejska-shared';

import { AbstractModule } from '../abstract.module';

export class AvailableBenefitsModule extends AbstractModule<BenefitResource> {
  public state = {
    list: []
  };
  public actions = {
    /**
     * Pobranie listy dostępnych usług dla klienta o danym numerze karty
     *
     * @param {*} context
     * @param {string} cardNumber
     */
    list: async (context: any, cardNumber: string) => {
      const partnerId = parseInt(sessionStorage.getItem(SessionStorage.PARTNER_ID) as string);
      const placeId = parseInt(sessionStorage.getItem(SessionStorage.PLACE_ID) as string);
      const { list } = await this.resource.availableBenefits(cardNumber, partnerId, placeId);
      context.commit('saveList', list);
    }
  };
  public mutations = {
    /**
     * Zapisanie listy dostępnych usług dla klienta
     *
     * @param {*} localState
     * @param {*} list
     */
    saveList: (localState: any, list: any[]) => {
      localState.list = [];
      localState.list.push(...list);
    }
  };

  constructor() {
    super(benefitResource);
  }
}

export default new AvailableBenefitsModule();
